import React, { useState } from 'react';
import { List, Row, Col, Modal } from 'antd';
import moment from 'moment';

import './index.scss';
import { any } from 'prop-types';

interface props {
  errorList: any;
}

const Error = (props: props) => {
  const { errorList } = props;
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [curItem, setCurItem] = useState<excepitonItem>({
    type: '',
    reportTime: '',
    errorMessage: '',
    errorCode: '',
    errorLevel: '',
    translateMessage: '',
  });
  const itemClick = (item: any) => {
    setCurItem(item);
    setErrorModalVisible(true);
  };
  return (
    <div className='error-con'>
      <List
        className='error-list'
        itemLayout='vertical'
        dataSource={errorList}
        renderItem={(item: any) => (
          <List.Item
            onClick={() => {
              itemClick(item);
            }}
          >
            <div className='m_b_5'>
              {moment(item.reportTime).format('HH:mm:ss')}
            </div>
            <div className='error-detail'>
              <Row>
                <Col span={10}>
                  <span className='gray-color-font'>错误码：</span>
                  <span>{item.errorCode}</span>
                </Col>
                <Col span={14}>
                  <span className='gray-color-font'>错误级别：</span>
                  <span>{item.errorLevel}</span>
                </Col>
                {item.errorLevel &&
                  item.errorLevel.toLocaleLowerCase() === 'fatal' && (
                    <div className='error-fatal'></div>
                  )}
              </Row>
              <Row>
                <span className='gray-color-font'>ErrorCode：</span>
              </Row>
              <Row>
                <Col span={24}>
                  {item.errorMessage &&
                    item.errorMessage.replace('ErrorCode: ', '')}
                </Col>
              </Row>
              {item.translateMessage && (
                <>
                  <Row>
                    <span className='gray-color-font'>翻译信息：</span>
                  </Row>
                  <Row>
                    <Col span={24}>{item.translateMessage ?? '--'}</Col>
                  </Row>
                </>
              )}
            </div>
          </List.Item>
        )}
      />
      <Modal
        title='错误信息'
        footer={null}
        maskClosable={false}
        visible={errorModalVisible}
        onCancel={() => {
          setErrorModalVisible(false);
        }}
      >
        <div className='error-modal-con'>
          <Row>
            <Col span={4} className='gray-color-font'>
              时间：
            </Col>
            <Col span={20}>{moment(curItem.reportTime).format('HH:mm:ss')}</Col>
          </Row>
          <Row>
            <Col span={4} className='gray-color-font'>
              错误码：
            </Col>
            <Col span={20}>{curItem.errorCode}</Col>
          </Row>
          <Row>
            <Col span={4} className='gray-color-font'>
              错误级别：
            </Col>
            <Col span={20}>{curItem.errorLevel}</Col>
          </Row>
          <Row>
            <Col span={4} className='gray-color-font'>
              ErrorCode：
            </Col>
            <Col span={20}>
              {curItem.errorMessage &&
                curItem.errorMessage.replace('ErrorCode: ', '')}
            </Col>
          </Row>
          {curItem.translateMessage && (
            <Row>
              <Col span={4} className='gray-color-font'>
                翻译信息：
              </Col>
              <Col span={20}>{curItem.translateMessage ?? '--'}</Col>
            </Row>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default React.memo(Error);
